import { render, staticRenderFns } from "./article.vue?vue&type=template&id=490988ea&"
import script from "./article.vue?vue&type=script&lang=ts&"
export * from "./article.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "article.vue"
export default component.exports